import { Paintbrush, ShieldCheck, Users, CheckCheck } from "lucide-react";
import companyMascot from "../../assets/images/working-bg.png";
import ResponsiveImage from "../common/ResponsiveImage";

const companyStrengths = [
  {
    title: "Đa dạng loại hình dịch vụ",
    icon: Paintbrush,
  },
  {
    title: "Chất lượng dịch vụ hàng đầu",
    icon: ShieldCheck,
  },
  {
    title: "Hợp tác với hàng triệu khách hàng",
    icon: Users,
  },
];

const commitments = [
  "Tư vấn và báo giá thiết kế website, dịch vụ SEO miễn phí.",
  "Thiết kế giao diện web theo yêu cầu.",
  "Đáp ứng mọi mong muốn về tính năng, bố cục, màu sắc, kiểu chữ, ... và nhiều ý tưởng khác nhau từ khách hàng.",
  "Lắng nghe mong muốn từ đó tư vấn cho khách hàng giao diện website phù hợp, vừa hợp ý khách, vừa đúng thị hiếu thị trường, đáp ứng về UI/UX.",
  "Các chức năng và thao tác trên website được tối ưu theo hành vi người dùng một cách tiện lợi và đơn giản nhất.",
];

const SectionWebsiteCompany: React.FC = () => {
  return (
    <section className="relative overflow-hidden bg-[linear-gradient(180deg,#ffffff_0%,#fff8f8_100%)] pb-16 pt-6 sm:pb-18 sm:pt-8 lg:pb-20 lg:pt-8">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute left-[-110px] top-10 h-72 w-72 rounded-full bg-red-100/70 blur-3xl" />
        <div className="absolute bottom-0 right-[-90px] h-80 w-80 rounded-full bg-rose-100/70 blur-3xl" />
      </div>

      <div className="container relative z-10 mx-auto px-4 sm:px-6">
        <div className="grid items-center gap-10 lg:grid-cols-[minmax(0,0.92fr)_minmax(0,1.08fr)] lg:gap-14">
          <div className="order-2 lg:order-1">
            <ResponsiveImage
              src={companyMascot}
              alt="TrioCore Solutions mascot"
              className="mx-auto h-auto w-full max-w-[500px] object-contain"
            />
          </div>

          <div className="order-1 text-left lg:order-2">
            <span className="inline-flex rounded-full border border-red-500/20 bg-red-50 px-4 py-2 text-[11px] font-semibold uppercase tracking-[0.18em] text-red-700">
              Đơn vị triển khai
            </span>

            <h2 className="mt-4 max-w-[680px] text-[24px] font-semibold leading-[1.2] text-[#d92d20] sm:text-[29px] lg:text-[36px]">
              Công Ty Thiết Kế Website TrioCore Solutions
            </h2>

            <div className="mt-7 grid gap-3 sm:grid-cols-3">
              {companyStrengths.map(({ title, icon: Icon }) => (
                <article
                  key={title}
                  className="rounded-[18px] border border-red-100 bg-[linear-gradient(180deg,#ffffff_0%,#fff7f7_100%)] px-3.5 py-3.5 shadow-[0_14px_28px_rgba(127,29,29,0.05)]"
                >
                  <div className="flex h-9 w-9 items-center justify-center rounded-full bg-[linear-gradient(180deg,#ff5a47_0%,#dc2626_100%)] text-white shadow-[0_7px_16px_rgba(220,38,38,0.16)]">
                    <Icon size={16} />
                  </div>
                  <p className="mt-3 text-[13px] font-semibold leading-5.5 text-[#2f1a1a]">{title}</p>
                </article>
              ))}
            </div>

            <div className="mt-8 space-y-4">
              {commitments.map((item) => (
                <div key={item} className="flex items-start gap-3">
                  <div className="mt-1 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-red-50 text-red-600">
                    <CheckCheck size={15} />
                  </div>
                  <p className="text-[14px] leading-8 text-slate-600">{item}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionWebsiteCompany;
